<phx-modal-confirm [phxOpen]="isVisible" phxSize="large" (phxBackdropClicked)="dismiss()">
  <div phx-modal-header style="position: relative;">
    <img
      height="310"
      width="100%"
      class="border-radius-top-left-4 border-radius-top-right-4 custom-img bg-grey-10"
      [src]="assetURL">
  
    <div (click)="dismiss()" class="close-icon-wrapper">
      <i phx-icon [size]="15" [phxIcon]="crossIcon" color="#9DACB9"></i>
    </div>
  </div>

  <div class="d-flex flex-col gap-16 align-items-center justify-center pb-24-imp pt-24-imp text-center border-bottom-1 border-grey-5" phx-modal-body phxNoPadding>
    <span class="phx-web-type-title-large w-80" [innerHTML]="heading"></span>
    <span class="phx-web-type-default w-80 phx-web-color-content-subdued" [innerHTML]="body"></span>
    <div class="d-flex gap-12 pt-8">
      <button
        *ngFor="let cta of CTAs"
        (click)="handleCTAClick(cta)"
        phx-button
        [phxButtonRole]="cta.action.is_primary ? 'primary' : 'secondary'"
      >
        {{ getCTAText(cta) }}
      </button>
    </div>
  </div>
  <div class="px-16 d-flex flex-col gap-8-imp" phx-modal-footer>
    <span class="phx-web-type-small phx-web-color-content-subdued">Get in touch with us to upgrade.</span>
    <div class="d-flex gap-16">
      <span class="phx-web-type-small phx-web-color-content-subdued d-flex align-items-center gap-4"><i phx-icon [size]="15" [phxIcon]="mobileIcon"></i>(855) 434-3564</span>
      <span class="phx-web-type-small phx-web-color-content-subdued d-flex align-items-center gap-4"><i phx-icon [size]="15" [phxIcon]="emailIcon"></i>sales&#64;gomotive.com</span>
    </div>
  </div>
</phx-modal-confirm>